import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
export function SegmentHighlight(_ref) {
  var segmentName = _ref.segmentName;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    segmentHighlight = _useState2[0],
    setSegmentHighlight = _useState2[1];
  useEffect(function () {
    try {
      var shouldHighlightSegments = sessionStorage.getItem('segmentsHighlight') === 'true';
      setSegmentHighlight(shouldHighlightSegments);
    } catch (err) {
      /* do nothing */
    }
  }, []);
  if (segmentHighlight) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
      React.createElement("span", {
        "data-segment-name": segmentName,
        style: {
          display: 'none'
        }
      })
    );
  }
  return null;
}